import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Section from "../components/ourProjects/Section";

const Projects = () => {
  return (
    <div>
      <Navbar />
      <Section />
      <Footer />
      
    </div>
  );
};

export default Projects;
